import { tooltipDriverFactory } from '../Tooltip/Tooltip.uni.driver';
import {
  baseUniDriverFactory,
  findByHook,
} from '../utils/test-utils/unidriver';
import { dataHooks } from './constants';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

const googlePreviewUniDriverFactory = (base: UniDriver, body: UniDriver) => {
  const getWebsiteInfoTooltip = () =>
    tooltipDriverFactory(
      findByHook(base, dataHooks.GooglePreviewWebsiteInfoTooltip),
      body,
    );

  return {
    ...baseUniDriverFactory(base),

    /** Get the current count */
    getPreviewUrl: async () =>
      findByHook(base, dataHooks.GooglePreviewPreviewUrl).text(),

    /** Click the button */
    getTitle: async () => findByHook(base, dataHooks.GooglePreviewTitle).text(),

    /** Get the button's text */
    getDescription: async () =>
      findByHook(base, dataHooks.GooglePreviewDescription).text(),

    /** Get site name */
    getSiteName: async () =>
      findByHook(base, dataHooks.GooglePreviewSiteName).text(),

    /** Triggers title mouse enter */
    titleMouseEnter: async () =>
      findByHook(base, dataHooks.GooglePreviewTitle).hover(),

    /** Triggers title mouse leave */
    titleMouseLeave: async () =>
      findByHook(base, dataHooks.GooglePreviewTitle).mouse.leave(),

    /** Triggers description mouse enter */
    descriptionMouseEnter: async () =>
      findByHook(base, dataHooks.GooglePreviewDescription).hover(),

    /** Triggers description mouse leave */
    descriptionMouseLeave: async () =>
      findByHook(base, dataHooks.GooglePreviewDescription).mouse.leave(),

    /** Clicks on the website info section */
    clickWebsiteInfo: async () =>
      findByHook(base, dataHooks.GooglePreviewWebsiteInfo).click(),

    /** Clicks the title */
    clickTitle: async () =>
      findByHook(base, dataHooks.GooglePreviewTitle).click(),

    /** Clicks the description */
    clickDescription: async () =>
      findByHook(base, dataHooks.GooglePreviewDescription).click(),

    /** Returns true if website info section has a tooltip */
    isWebsiteInfoTooltipEnabled: async () => getWebsiteInfoTooltip().exists(),

    /** Returns true if website info section tooltip exists on the DOM*/
    isWebsiteInfoTooltipExists: async () =>
      getWebsiteInfoTooltip().tooltipExists(),

    /** Returns content of website info section tooltip */
    getWebsiteInfoTooltipContent: async () =>
      getWebsiteInfoTooltip().getTooltipText(),

    /** Triggers tooltip mouse enter */
    websiteInfoTooltipMouseEnter: async () =>
      getWebsiteInfoTooltip().mouseEnter(),
  };
};

export default googlePreviewUniDriverFactory;

export type GooglePreviewUniDriver = ReturnType<
  typeof googlePreviewUniDriverFactory
>;
